if (!Shopify.designMode) {
  const resizeObserver = new ResizeObserver((entries) => {
    if (!theme.config.initialResizeHandled) {
      theme.config.initialResizeHandled = true;
      return;
    }
    const now = performance.now();
    const timeSinceLastResize = now - theme.config.lastResizeTime;
    theme.config.lastResizeTime = now;
    const debounceTime = Math.min(Math.max(timeSinceLastResize, 1), 2500);
    clearTimeout(theme.config.resizeTimer);
    theme.config.resizeTimer = setTimeout(() => {
      for (let entry of entries) {
        console.log(
          `%c Resized: ${entry.target.tagName} | Delay: ${debounceTime}ms`,
          'color: orange; font-weight: bold;'
        );
      }
      ScrollTrigger.refresh(true);
    }, debounceTime);
    theme.utils.throttle(theme.utils.setScrollbarWidth);
  });
  document.addEventListener('DOMContentLoaded', () => {
    const getPreloaderCookie = getCookiePreloader("theme_preloader_first_load");
    const getPreloaderTextShowSetting = document.body.getAttribute("data-preloader-text-visibility");
    const textPreloader = document.body.getAttribute("data-preloader-text");
    const getPreloaderShowSetting = document.body.getAttribute("data-preloader-text-appearance");
    const getPreloaderPageName = document.body.getAttribute("data-preloader-template");
    if(getPreloaderCookie && getPreloaderShowSetting == 'once'){
      document.body.setAttribute("data-preloader-text","");
    }
    if(getPreloaderTextShowSetting == 'homepage-only' && getPreloaderPageName == 'index'){
        if(getPreloaderShowSetting == 'once'){
          if(!getPreloaderCookie && textPreloader != ''){
            colorUpdateBodyContentLoad();
            setCookiePreloader("theme_preloader_first_load","done", 3);
          }
        }else{
          deleteCookiePreloader("theme_preloader_first_load");
          colorUpdateBodyContentLoad();
        }
    } else {
      deleteCookiePreloader("theme_preloader_first_load");
      colorUpdateBodyContentLoad();
    }
    gsapSectionIntializationBatches();
  });
  window.addEventListener('load', () => {
    let existingTriggers = ScrollTrigger.getAll();
    if (existingTriggers.length == 0) {
      gsap.to('#progress-container', { opacity: 0, duration: 0.1, visibility: 'hidden' });
    }
  });
  function gsapSectionIntializationBatches() {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isMobileViewport = window.innerWidth <= 767;
    let allSections = document.querySelectorAll('[mayaaThemeSection]');
    let batchSize = 3;
    let delayBetweenBatches = 50;
    let classObjectIntiate = new gsapMayaaThemeExecution();
    let totalSections = allSections.length;
    if(totalSections === 0) {
      document.body.classList.remove('animation-intialize-started');
      document.querySelector('html').classList.remove('no-animation');
      document.querySelector('[data-edge-split]')?.remove();
      if(!isTouchDevice){
        classObjectIntiate.lenisIntializationData();
      }
      const customScrollbar = new CustomScrollbar();
    }
    let progressBar = document.getElementById('progress-bar');
    let processedSections = 0;
    let targetProgress = 0;
    let currentProgress = 0;
    let progressTween;
    function updateProgressBar() {
      const smoothDuration = 0.3;
      if (progressTween) progressTween.kill();
      const targetTranslateX = -100 + targetProgress;
      progressTween = gsap.to({ value: currentProgress }, {
        value: targetProgress,
        duration: smoothDuration,
        ease: "power1.out",
        onUpdate: function () {
          currentProgress = this.targets()[0].value;
          const translateX = -100 + currentProgress;
          progressBar.style.transform = `translateX(${translateX}%)`;
        }
      });
    }
    function processBatchSection(startIndex) {
      requestAnimationFrame(() => {
        for (let i = startIndex; i < startIndex + batchSize && i < totalSections; i++) {
          let section = allSections[i];
          let methodCalled = section.getAttribute('methodCalled')?.trim();
          const enableMobileAnimation = section.getAttribute('data-enable-mobile-animation') !== 'false';
          if (
            (!isMobileViewport || enableMobileAnimation) &&
            methodCalled &&
            typeof classObjectIntiate[methodCalled] === 'function'
          ) {
            classObjectIntiate[methodCalled](section);
          }
          processedSections++;
        }
        targetProgress = (processedSections / totalSections) * 100;
        updateProgressBar();
        if (startIndex + batchSize < totalSections) {
          setTimeout(() => processBatchSection(startIndex + batchSize), delayBetweenBatches);
        } else {
          let totalBatchedTime = (totalSections / batchSize) * delayBetweenBatches;
          let sectionHeaderLogoScale = document.querySelector('[mayaathemesectionheader]');
          if (sectionHeaderLogoScale) {
            let methodCalledHeader = sectionHeaderLogoScale.getAttribute('methodCalled')?.trim();
            if (methodCalledHeader && typeof classObjectIntiate[methodCalledHeader] === 'function') {
              if (totalBatchedTime < 150) {
                setTimeout(() => {
                  classObjectIntiate[methodCalledHeader](sectionHeaderLogoScale);
                  ScrollTrigger.refresh(true);
                  gsap.to(progressBar, {
                    width: '100%',
                    duration: 0.1,
                    ease: 'power2.out',
                    onComplete: () => {
                      document.body.classList.add('animation-intialization-complete');
                      document.querySelector('html').classList.remove('no-animation');
                      gsap.to('#progress-container', { opacity: 0, duration: 0.1, visibility: 'hidden' });
                      manageClassesLoader();
                      theme.DOMready(theme.utils.setScrollbarWidth);
                    },
                  });
                }, 200);
              } else {
                classObjectIntiate[methodCalledHeader](sectionHeaderLogoScale);
                setTimeout(() => {
                  ScrollTrigger.refresh(true);
                  gsap.to(progressBar, {
                    width: '100%',
                    duration: 0.1,
                    ease: 'power2.out',
                    onComplete: () => {
                      document.body.classList.add('animation-intialization-complete');
                      document.querySelector('html').classList.remove('no-animation');
                      gsap.to('#progress-container', { opacity: 0, duration: 0.1, visibility: 'hidden' });
                      manageClassesLoader();
                      theme.DOMready(theme.utils.setScrollbarWidth);
                    },
                  });
                }, 10);
              }
            }
          } else {
            let timeMs = 50;
            let existingTriggersToRrefresh = ScrollTrigger.getAll();
            if (existingTriggersToRrefresh.length > 15) {
              timeMs = 150;
            }
            setTimeout(() => {
              ScrollTrigger.refresh(true);
              gsap.to(progressBar, {
                width: '100%',
                duration: 0.1,
                ease: 'power2.out',
                onComplete: () => {
                  //document.body.classList.remove('animation-intialize-started');
                  document.body.classList.add('animation-intialization-complete');
                  document.querySelector('html').classList.remove('no-animation');
                  gsap.to('#progress-container', { opacity: 0, duration: 0.1, visibility: 'hidden' });
                  document.querySelector('[data-edge-split]')?.classList.add('completed');
                  manageClassesLoader();
                  theme.DOMready(theme.utils.setScrollbarWidth);
                },
              });
            }, timeMs);
          }
          if(!isTouchDevice){
            classObjectIntiate.lenisIntializationData();
          }
          const customScrollbar = new CustomScrollbar();
          updateAllRotatingTexts();
        }
      });
    }
    if (totalSections > 0) {
      processBatchSection(0);
    }
  }
  function colorUpdateBodyContentLoad(colorIndex = 0) {
    let allSectionsData = document.querySelectorAll('[mayaaThemeSection]');
    let batchSizeData = 3;
    let delayBetweenBatchesData = 50;
    let timeDelayloader = (allSectionsData.length / batchSizeData) * delayBetweenBatchesData;
    if (document.body.classList.contains('animation-intialization-complete')) {
      setTimeout(() => {
        document.body.classList.remove('animation-intialize-started');
        document.body.classList.remove('animation-intialization-complete');
        document.body.removeAttribute('data-preloader-text');
        document.querySelector('[data-edge-split]')?.classList.add('completed');
      },1000);
      return;
    }
    if(document.body.classList.contains('animation-intialize-started')) {
      document.body.style.setProperty('--preloader-background', colorDefined[colorIndex % colorDefined.length]);
      document.body.style.setProperty('--preloader-text', textcolorDefined[colorIndex % textcolorDefined.length]);
      if(textDefined.length > 0){
        document.body.setAttribute('data-preloader-text', textDefined[colorIndex % textDefined.length]);
      }
      setTimeout(() => {
        colorUpdateBodyContentLoad(colorIndex + 1);
      }, 50);
    }
  }
  function manageClassesLoader(){
    const getPreloaderTextShowSettingClass = document.body.getAttribute("data-preloader-text-visibility");
    const getPreloaderShowSettingClass = document.body.getAttribute("data-preloader-text-appearance");
    if(getPreloaderTextShowSettingClass == 'homepage-only' && getPreloaderShowSettingClass == 'once'){
        if (document.body.classList.contains('animation-intialization-complete')) {
          setTimeout(() => {
            document.body.classList.remove('animation-intialize-started');
            document.body.classList.remove('animation-intialization-complete');
            document.body.removeAttribute('data-preloader-text');
            document.querySelector('[data-edge-split]')?.classList.add('completed');
          },1000);
          return;
        }
    }
  }
  function updateAllRotatingTexts() {
    document.querySelectorAll('rotating-text').forEach((el) => {
      el.applyRotation?.();
    });
  }
  function setCookiePreloader(name, value, hours = 3) {
      const now = new Date();
      now.setTime(now.getTime() + (hours * 60 * 60 * 1000));
      const expires = "expires=" + now.toUTCString();
      document.cookie = `${name}=${value}; ${expires}; path=/`;
  }
  function getCookiePreloader(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, val] = cookie.split("=");
      if (key === name) return val;
    }
    return null;
  }
  function deleteCookiePreloader(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}
